<h2 mat-dialog-title>Выберите карточку Exist</h2>

<div mat-dialog-content class="dialogContent">
  <p class="dialogHint">
    Для артикула <strong>{{ data.article }}</strong> найдено несколько вариантов. Выберите нужный,
    чтобы продолжить импорт.
  </p>

  <div class="candidateList">
    <mat-card
      *ngFor="let candidate of data.candidates; trackBy: trackByExistId"
      class="candidateCard"
    >
      <div class="candidateMedia">
        <img
          *ngIf="candidate.image; else noImageState"
          class="candidateImage"
          [src]="candidate.image"
          [alt]="candidate.description"
        />

        <ng-template #noImageState>
          <div class="candidateImagePlaceholder">
            <mat-icon>image_not_supported</mat-icon>
            <span>Нет фото</span>
          </div>
        </ng-template>
      </div>

      <div class="candidateBody">
        <div class="candidateTopRow">
          <div>
            <div class="candidateBrand">{{ candidate.brand }}</div>
            <div class="candidateArticle">{{ candidate.article }}</div>
          </div>

          <button mat-flat-button color="primary" type="button" (click)="choose(candidate)">
            Выбрать
          </button>
        </div>

        <div class="candidateDescription">{{ candidate.description }}</div>
        <a class="candidateLink" [href]="candidate.exist_url" target="_blank" rel="noreferrer">
          Открыть на Exist
        </a>
      </div>
    </mat-card>
  </div>
</div>

<div mat-dialog-actions align="end">
  <button mat-stroked-button type="button" (click)="dialogRef.close()">Отмена</button>
</div>
